module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-500.93553e98363f8e91ea2f.woff2";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-500.woff2
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-500.woff2
// module chunks = styles